/**
 * Was neben dem Monat (Desktop) oder im Blatt (Handy) steht: mit Edit der Editor samt Preisautomatik
 * der Auswahl; ohne Edit, aber mit Preisautomatik-Rolle das Tagesdetail eines angetippten Tags – wie
 * im früheren Preisautomatik-Kalender, ohne „wieder automatisch“.
 */
import type { AvailabilityDistributionApartment } from '@/shared/api';
import { MonthDayDetail } from '../automation/MonthDayDetail';
import { SelectionAutomation } from '../automation/SelectionAutomation';
import type { InlineEditorValues } from '../calendar/inlineEditorModel';
import type { IsoRange } from '../calendar/rangePickerModel';
import type { SelectedRange } from '../calendar/rangeSelectionModel';
import { MonthEditor } from './MonthEditor';

interface Props {
  propertyGroupId: string;
  apartment: AvailabilityDistributionApartment;
  today: string;
  canEdit: boolean;
  inspectOnly: boolean;
  ranges: readonly SelectedRange[];
  values: InlineEditorValues;
  onValuesChange: (values: InlineEditorValues) => void;
  onRemoveRange: (id: string) => void;
  onPatchRange: (id: string, range: IsoRange) => void;
  onAddRange: (range: IsoRange) => void;
  onClear: () => void;
  onPushed: () => void;
}

export function MonthSide({
  propertyGroupId,
  apartment,
  canEdit,
  inspectOnly,
  ranges,
  ...props
}: Props) {
  if (canEdit) {
    return (
      <MonthEditor
        apartment={apartment}
        ranges={ranges}
        {...props}
        extra={
          <SelectionAutomation
            propertyGroupId={propertyGroupId}
            propertyId={apartment.propertyId}
            ranges={ranges}
            canEdit
          />
        }
      />
    );
  }
  if (!inspectOnly) return null;
  const day = ranges[0]?.from;
  return (
    <div className="p-[22px]">
      {day ? (
        <MonthDayDetail
          propertyGroupId={propertyGroupId}
          propertyId={apartment.propertyId}
          date={day}
          canEdit={false}
        />
      ) : (
        <p className="text-ink-soft text-sm">
          Einen Tag anklicken, um das Tagesdetail der Preisautomatik zu sehen.
        </p>
      )}
    </div>
  );
}
